angular
    .module("skillBuilderSaaS")
    .directive("sbLoading", function () {
    return {
        scope: {
            showText: "=",
        },
        template: "<i class='fa fa-circle-o-notch fa-spin'></i> <span ng-if='$ctrl.showText' translate='common.loading'></span>"
    };
});
